import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import instance from '@src/api/axiosInstance';

const deleteAnalysisTemplate = async (id: number): Promise<any> => {
  const response = await instance.delete(`/nexa/analysis-templates/${id}`);
  return response.data;
};

export const useDeleteAnalysisTemplate = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteAnalysisTemplate,
    onSuccess: () => {
      message.success('Analysis template deleted successfully');
      queryClient.invalidateQueries({ queryKey: ['analysis-templates'] });
      queryClient.invalidateQueries({ queryKey: ['analysis-tags'] });
      queryClient.invalidateQueries({ queryKey: ['my-analyses'] });
      queryClient.invalidateQueries({ queryKey: ['team-analyses'] });
      queryClient.invalidateQueries({ queryKey: ['recommended-analyses'] });
    },
    onError: (error: any) => {
      message.error(error?.response?.data?.error?.message || 'Failed to delete analysis template');
    },
  });
};
